<template>
  <div>
    <apexchart
      v-if="mealCategories.length"
      type="bar"
      :height="Math.max(360, mealCategories.length * 34 + 80)"
      :options="mealsOpts"
      :series="mealsSeries"
    />
    <div
      v-else
      class="d-flex justify-center align-center grey--text text--lighten-1"
      style="min-height: 400px"
    >
      <span class="text-body-2">{{ $t("no_data") }}</span>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

const SHIFT_COLORS = ["#1E88E5", "#43A047", "#FB8C00", "#8E24AA"];

export default {
  name: "GroupMealsMealsChart",
  components: { apexchart: VueApexCharts },
  props: {
    orders: { type: Array, default: () => [] },
  },
  computed: {
    shiftLabels() {
      return [
        this.$t("1st_shift"),
        this.$t("2nd_shift"),
        this.$t("3rd_shift"),
        this.$t("4th_shift"),
      ];
    },
    mealAgg() {
      const map = {};
      for (const item of this.orders) {
        const n = item.meal_name;
        if (!map[n]) map[n] = [0, 0, 0, 0];
        const s = (item.shift || 1) - 1;
        if (s >= 0 && s < 4) map[n][s] += Number(item.quantity || 0);
      }
      return map;
    },
    sortedMealEntries() {
      return Object.entries(this.mealAgg)
        .map(([name, shifts]) => ({
          latinName: this.toLatin(name),
          total: shifts.reduce((a, b) => a + b, 0),
          shifts,
        }))
        .sort((a, b) => b.total - a.total);
    },
    mealCategories() {
      return this.sortedMealEntries.map((m) => m.latinName);
    },
    mealsSeries() {
      return this.shiftLabels.map((label, i) => ({
        name: label,
        data: this.sortedMealEntries.map((m) => m.shifts[i] || 0),
      }));
    },
    mealsOpts() {
      return {
        chart: {
          type: "bar",
          stacked: true,
          toolbar: {
            show: true,
            tools: {
              download: true,
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false,
            },
          },
          fontFamily: "Roboto, sans-serif",
        },
        plotOptions: { bar: { horizontal: true, borderRadius: 3, barHeight: "70%" } },
        colors: SHIFT_COLORS,
        xaxis: { categories: this.mealCategories, labels: { style: { fontSize: "12px" } } },
        yaxis: { labels: { style: { fontSize: "12px" }, maxWidth: 220 } },
        legend: { position: "bottom", horizontalAlign: "center" },
        dataLabels: { enabled: false },
        tooltip: { shared: true, intersect: false },
        fill: { opacity: 1 },
        grid: { borderColor: "#f1f1f1" },
      };
    },
  },
};
</script>
